export const getDefault = () => {
  const schema = {
    name: 'Numbers',
    backgroundColor: '#000',
    titleColor: '#FFF',
    textColor: '#FFF',
    lineColor: '#FFF',
    sectionTitleColor: '#FFF',
    hasDate: false,
    sectionTitle: 'Título',
    hasSectionTitle: true,
    data: [
      {
        title: 'ano de criação',
        number: '1973'
      },
      {
        title: 'departamentos',
        number: '16'
      },
      {
        title: 'escolas politécnicas',
        number: '04'
      },
      {
        title: 'estudantes',
        number: '+13k'
      }
    ]
  }
  return schema
}
